let wc_result='';
let return_current_wishlist_selected_id=()=>{
   let wishlist_tabs_label=document.querySelectorAll('.tab-link .tab-link-label');
   let current_select_tab_text='';
   let current_selected_wishlist_id='';
   wishlist_tabs_label.forEach((label)=>{
     if(label.closest('.tab-link').classList.contains('current')){
       current_select_tab_text=label.innerText;
     }
   })
   let wishlists=wc_result.data.wishlists;
   if(wishlists){
     wishlists.forEach((wishlist)=>{
       if(wishlist.name==current_select_tab_text){
         current_selected_wishlist_id=wishlist.id;
       }
     })
   }
  return current_selected_wishlist_id;
 }

let wc_custom_copy_wishlist=()=>{
  function copy_to_clipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    document.execCommand('copy');
    document.body.removeChild(textarea);
    console.log('Text copied to clipboard');
  }
   let wc_custom_header_label=document.querySelector('.wc_custom_header_label');
   (wc_custom_header_label)?wc_custom_header_label.innerText='Link Copied':'';
   copy_to_clipboard(`${Shopify.shop}/apps/wishlist/?wlid=${return_current_wishlist_selected_id()}`);

  setTimeout(()=>{
     (wc_custom_header_label)?wc_custom_header_label.innerText='Share wishlist':'';
  },2000)
}
let wc_custom_ATC_event=()=>{
   let add_to_cart_all_product_btn=document.querySelector('.add-to-cart-all-product-btn')
   if(add_to_cart_all_product_btn){
     add_to_cart_all_product_btn.click();
   }
}
let wc_set_sharing_and_ATC_btn=()=>{
  let wishlist_header=document.querySelector('.th-wl-container-header');
  let wc_share_structure='';
  if(wc_result.data.total>0){
    wc_share_structure+=`<div class='wc_custom_top_header_sharing'>`;
       wc_share_structure+=`<div class='wc_custom_copy_share' onClick="wc_custom_copy_wishlist()">`;
         wc_share_structure+=`<span><svg viewBox="0 0 24 24"><path d="M20 13v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6M12 15V3m0 0L8.5 6.5M12 3l3.5 3.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>`;
         wc_share_structure+=`<span class='wc_custom_header_label'>Share wishlist</span>`
       wc_share_structure+=`</div>`;
  
       wc_share_structure+=`<div class='wc_custom_ATC_btn' onCLick="wc_custom_ATC_event()">`;
         wc_share_structure+=`<span><svg viewBox="0 0 24 24"><path d="M19.26 9.696l1.385 9A2 2 0 0118.67 21H5.33a2 2 0 01-1.977-2.304l1.385-9A2 2 0 016.716 8h10.568a2 2 0 011.977 1.696zM14 5a2 2 0 10-4 0" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>`;
         wc_share_structure+=`<span class='wc_custom_header_label'>Add wishlist to Bag</span>`
       wc_share_structure+=`</div>`
    wc_share_structure+=`</div>`;
  }else{
    let wishlist_settings=JSON.parse(localStorage.getItem('th_default_settings_content'))
    wc_share_structure+=`<div class="wc_empty_wishlist_msg">${(wishlist_settings.data.setting.no_product)?wishlist_settings.data.setting.no_product:'Your Wishlist is Empty!'}</div>`;
    wc_share_structure+=`<div class='wc_custom_empty_wishlist_btn'>`;
     wc_share_structure+=`<a href='https://${Shopify.shop}'><span>Back Home</span></a>`;
    wc_share_structure+=`</div>`;
  }

  wishlist_header.insertAdjacentHTML('beforeend', wc_share_structure);
}
let wc_wishlist_items_added_callback=(result)=>{
  wc_result=result;
  setTimeout(()=>{
    wc_set_sharing_and_ATC_btn();
  },500)
}